import { useMediaQuery } from 'react-responsive';
import { DESKTOP_MIN_WIDTH } from '@bg-shared/constants';

export const useMobileView = (breakpoint = DESKTOP_MIN_WIDTH): boolean =>
    useMediaQuery({
        // need to decrease by 1px, because e.g.:
        // "max-width: 768px" and "min-width: 768px" (in CSS) overlap at exact resolution
        query: `(max-width: ${breakpoint - 1}px)`,
    });
